import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { CrisisPage } from './pages/CrisisPage';
import { EarthViewPage } from './pages/EarthViewPage';
import { EventsPage } from './pages/EventsPage';
import { ForecastPage } from './pages/ForecastPage';
import { DataCatalogPage, LayersPage, ProjectsPage, SettingsPage } from './pages/GenericPages';
import { InfrastructurePage } from './pages/InfrastructurePage';
import { MobilityPage } from './pages/MobilityPage';
import { OverviewPage } from './pages/OverviewPage';
import { SearchPage } from './pages/SearchPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/map" element={<EarthViewPage />} />
          <Route path="/crises" element={<CrisisPage />} />
          <Route path="/infrastructure" element={<InfrastructurePage />} />
          <Route path="/mobility" element={<MobilityPage />} />
          <Route path="/forecast" element={<ForecastPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/layers" element={<LayersPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/catalog" element={<DataCatalogPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
